module.exports = __webpack_public_path__ + "img/kumice.93808eb0.jpg";